/* Real thresholds pulled from the Optical Frames / Sunglasses size tables,
   expressed as [smallUpperBound, mediumUpperBound] per frame shape. Anything
   above the medium bound is Large. Loaded before the main module script so
   window.SIZE_CHART is ready when the popup's size-check form needs it.

   Note: these bounds are eye-size-only. A separate business rule in
   face-shape-identifier.js (resolveSize()) overrides the result when the
   customer's nose bridge is 19mm or more — Small is skipped entirely in
   that case (Small→Medium, Medium→Large). */
window.SIZE_CHART = {
  optical: {
    "Square":[50,55], "Rectangle":[50,55], "Wayfarer":[50,55], "Round / Panto":[46,50],
    "Oval":[50,55], "Cat Eye":[51,56], "Aviator":[51,56], "Modified Aviator":[51,56],
    "Browline":[50,55], "Geometric":[50,55], "Butterfly":[51,56], "Other Styles":[50,55]
  },
  sunglasses: {
    "Square":[52,58], "Rectangle":[52,58], "Wayfarer":[52,58], "Round / Panto":[50,54],
    "Oval":[52,58], "Cat Eye":[52,58], "Aviator":[52,58], "Modified Aviator":[52,58],
    "Browline":[52,58], "Geometric":[52,58], "Butterfly":[52,58], "Other Styles":[52,58]
  }
};